import { render, staticRenderFns } from "./ExtraDetailsCard.vue?vue&type=template&id=2db5b72a&scoped=true"
import script from "./ExtraDetailsCard.vue?vue&type=script&lang=ts"
export * from "./ExtraDetailsCard.vue?vue&type=script&lang=ts"
import style0 from "./ExtraDetailsCard.vue?vue&type=style&index=0&id=2db5b72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5b72a",
  null
  
)

export default component.exports